import z from "zod"
import { CompanyActionEnum, CompanyIntegrationProviderEnum } from "./dtos"

export const UpdateCompanyIntegrationConfigurationResponseData = z.object({
  action: CompanyActionEnum,
  provider: CompanyIntegrationProviderEnum,
  isActive: z.boolean(),
})

export const UpdateCompanyIntegrationConfigurationsResponseData = z.array(
  UpdateCompanyIntegrationConfigurationResponseData,
)
